/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Application_Overview_Status_ReviewInputs */

const en_landing_application_overview_status_review = /** @type {(inputs: Landing_Application_Overview_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready for review`)
};

const de_landing_application_overview_status_review = /** @type {(inputs: Landing_Application_Overview_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit zur Prüfung`)
};

const fr_landing_application_overview_status_review = /** @type {(inputs: Landing_Application_Overview_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prête à être examinée`)
};

const es_landing_application_overview_status_review = /** @type {(inputs: Landing_Application_Overview_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista para revisar`)
};

const it_landing_application_overview_status_review = /** @type {(inputs: Landing_Application_Overview_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronta per la revisione`)
};

const nl_landing_application_overview_status_review = /** @type {(inputs: Landing_Application_Overview_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaar voor beoordeling`)
};

const pl_landing_application_overview_status_review = /** @type {(inputs: Landing_Application_Overview_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gotowa do sprawdzenia`)
};

const fi_landing_application_overview_status_review = /** @type {(inputs: Landing_Application_Overview_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmis tarkistettavaksi`)
};

const da_landing_application_overview_status_review = /** @type {(inputs: Landing_Application_Overview_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar til gennemgang`)
};

const sv_landing_application_overview_status_review = /** @type {(inputs: Landing_Application_Overview_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar för granskning`)
};

/**
* | output |
* | --- |
* | "Ready for review" |
*
* @param {Landing_Application_Overview_Status_ReviewInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_application_overview_status_review = /** @type {((inputs?: Landing_Application_Overview_Status_ReviewInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Application_Overview_Status_ReviewInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_application_overview_status_review(inputs)
	if (locale === "fr") return fr_landing_application_overview_status_review(inputs)
	if (locale === "es") return es_landing_application_overview_status_review(inputs)
	if (locale === "it") return it_landing_application_overview_status_review(inputs)
	if (locale === "nl") return nl_landing_application_overview_status_review(inputs)
	if (locale === "pl") return pl_landing_application_overview_status_review(inputs)
	if (locale === "fi") return fi_landing_application_overview_status_review(inputs)
	if (locale === "da") return da_landing_application_overview_status_review(inputs)
	if (locale === "sv") return sv_landing_application_overview_status_review(inputs)
	return en_landing_application_overview_status_review(inputs)
});